export const SET_LOADING = 'loading/SET_LOADING';